module.exports = __webpack_public_path__ + "static/media/tab-settings.628be84e.png";